module.exports = __webpack_public_path__ + "static/media/Frome_App Download.b34a92b2.png";